import whiteLabelledSolution from "../../assets/images/white-labelled-solution.svg";
import nonInterfaceApis from "../../assets/images/non-interface-apis.svg";
import softwareDevKits from "../../assets/images/software-dev-kits.svg";
import SmallCaseIcon from "../../assets/images/smallcase-partner.svg";
import StratzyIcon from "../../assets/images/stratzy-partner.svg";
import FiveNanceIcon from "../../assets/images/5nance-partner.svg";
import PivotTradingIcon from "../../assets/images/pivot-trading-partner.svg";
import QuantsappIcon from "../../assets/images/quantsapp-partner.svg";

import moment from "moment";

interface CommenConstants {
  ErrorTimeout: number;
  LoadArticle: number;
  LoadVideo: number;
  MinFaqs: number;
  MaxFaqs: number;
  Video: number;
  Article: number;
  resourceDateFormat: string;
  DateFormatWithTime: string;
}

export const constants: CommenConstants = {
  ErrorTimeout: 7000,
  Video: 3,
  Article: 4,
  MinFaqs: 0,
  MaxFaqs: 4,
  LoadArticle: 4,
  LoadVideo: 2,
  resourceDateFormat: "DD MMM YYYY",
  DateFormatWithTime: "DD MMM YYYY , hh : mm A",
};

export const ResourceObject = {
  pageDate: "",
  pageLimit: 0,
  tag: [],
};

export const removeServerErrors = (
  setServerErrors: CallableFunction,
  timing: number
) => {
  setTimeout(() => {
    setServerErrors();
  }, timing);
};

export const LoginKeys = {
  Vendor: "vendor",
  Client: "client",
  AccessToken: "access_token",
};

export const keyClockclient = {
  clientID: "vendor_partner",
  clientName: "",
  scope: "",
};

export const passwordHints = {
  checkLength: "Password length should be between 6-12 characters",
  sameAsLoginId: "Your Login ID & Password should not be the same",
  NoSpace: "No spaces allowed between characters",
  upLowCase: "At least one upper and one lower case character",
  alpNumSpcl: "At least one alphanumeric/special character",
  splNotAllow: `Special characters not allowed are
  ${`(   ) > <  ?  ,  %  -  +  :   ;   [    ]  {   }   |   ~ ${"`"} ^ _  “  /  ₹`}`,
};

export const DateFormat = (date: Date, format: string) => {
  console.log("date", date);
  return moment(date).format(format);
};

export const slicedData = (commData: [], minData: number, maxData: number) => {
  return commData.slice(minData, maxData);
};

export const addTolocalStorage = (name: string, val: string | boolean) => {
  localStorage.setItem(name, JSON.stringify(val));
};

export const getTolocalStorage = (name: string) => {
  let result = localStorage.getItem(name);
  return result ? JSON.parse(result) : "";
};

export const removeTolocalStorage = (name: string) => {
  localStorage.removeItem(name);
};

export const Offers = [
  {
    title: "White labelled solution",
    description:
      "Integrate transaction capability on your web and mobile application with trade button. Build your full-fledged investment platform using our APIs and have us deal with the operational and regulatory details.",
    image: whiteLabelledSolution,
  },
  {
    title: "Non Interface APIs",
    description:
      "Manage the entire order placement and tracking experience at your end using our non-interfac APIs. Access available to callbacks and end of day recon APIs as well.",
    image: nonInterfaceApis,
  },
  {
    title: "Software Dev Kits (SDKs)",
    description:
      "SDKs are available for both Android and iOS for quick integration into your mobile App. Native SDKs are under development.",
    image: softwareDevKits,
  },
];

export const OfferTitle = {
  HOME_TITLE: "Startup & Fintech Offerings",
  SIGNUP_TITLE: "Our Offerings",
};

export const GetAccecssTitle = {
  HOME_TITLE: "Get Free Access to Nuvama API Connect which includes",
  SIGNUP_TITLE: "Get exclusive access to our advance APIs for FREE",
};

export const GetAccessHome = [
  { heading: "Robust APIs built to handle trading at scale" },
  { heading: "Access live market feeds through WebSocket stream" },
  { heading: "Secure connection via ", sub_heading: "OAuth" },
  {
    heading:
      "View trades, place orders and access your account securely in real time",
  },
  {
    heading:
      "Analyze your trading behavior on APIs using our intuitive dashboard",
  },
  {
    heading: "Access to quality",
    sub_heading: "customer support",
  },
];
export const GetAccessSignup = [
  { heading: "Robust APIs built to handle trading at scale" },
  { heading: "Secure connection via ", sub_heading: "OAuth" },
  { heading: "Trade execution with high reliability and speed" },
  {
    heading: "View trades and place orders securely in real time",
  },
  {
    heading: "Access live market feeds through WebSocket stream",
  },
  {
    heading:
      "Analyze your trading behaviour on APIs using our intuitive dashboard",
  },
];

export const PartnersDetails = [
  { name: "SmallCase", icon: SmallCaseIcon },
  { name: "Stratzy", icon: StratzyIcon },
  { name: "5Nance", icon: FiveNanceIcon },
  { name: "Pivot-Trading", icon: PivotTradingIcon },
  { name: "Quantsapp", icon: QuantsappIcon },
];

export const errorsMsg = {
  commonError: "Something went wrong, Please try again later",
};
